export default __webpack_public_path__ + "static/media/image-phone-and-keyboard.da1835ce.jpg";